exports = module.exports = require("../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal{width:100px;height:100px;border:1px solid #ccc}", ""]);

// exports
